<template>
  <div class="indicatorSetting" v-if="!loading">
    <!-- 已添加指标 -->
    <form-item
      class="item"
      v-for="(item) in indicatorList"
      :key="item.id"
      :item-list="itemList"
      :dimension="detail"
      :item-data="item"
      @refresh="fetchIndicatorList()"
    >
    </form-item>
    <!-- 待添加指标 -->
    <form-item
      class="item"
      v-for="(item, index) in addList"
      :key="`add${index}`"
      :item-list="itemList"
      :dimension="detail"
      :item-data="item"
      :is-create="true"
      @cancelAdd="addList.splice(index, 1)"
      @refresh="fetchIndicatorList()"
    >
    </form-item>

    <div class="add-container">
      <a-button
        type="dashed"
        icon="plus"
        @click="handleAdd"
        style="width: 100%; margin-top: 12px"
      >
        添加指标
      </a-button>
    </div>
  </div>
</template>

<script>
import { getServiceHealthIndicatorList, getServiceHealthItemList } from '@/api/service-health.js'
import FormItem from './FormItem.vue'

export default {
  name: 'IndicatorSetting',
  components: {
    FormItem
  },
  props: {
    detail: {
      type: Object
    }
  },
  data () {
    return {
      loading: true,
      itemList: [],
      indicatorList: [], // 已添加指标集合
      addList: [], // 待添加指标集合
      addForm: [],
      form: {
        indicators: []
      }
    }
  },
  created () {
    this.fetchIndicatorList()
    this.fetchItemList()
  },
  methods: {
    fetchIndicatorList () {
      getServiceHealthIndicatorList({ dimension_id: this.detail.id }).then(res => {
        this.indicatorList = res.data.data
      }).catch(() => {})
    },
    fetchItemList () {
      this.loading = true
      getServiceHealthItemList({ dimension: this.detail.source_type }).then(res => {
        this.itemList = res.data.data
      }).finally(() => {
        this.loading = false
      })
    },
    handleAdd () {
      this.addList.push({
        dimension_id: this.detail.id,
        source_type: this.detail.source_type,
        key: '',
        method: '',
        condition: '',
        value: 0,
        proportion: 0
      })
    },
    handleDeleteAdd (index) {
      this.addList.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.indicatorSetting {
  margin-top: -12px;
  .item {
    margin-bottom: 6px;
  }
  :deep(.ant-form-item-control) {
    line-height: 32px;
    .ant-form-explain {
      position: absolute;
      font-size: 13px;
    }
  }
}
</style>
